
// Utility functions for lead table display

/**
 * Standard minimum column widths for the lead table
 */
export const getMinColumnWidths = () => ({
  toggle: 30,
  name: 120,
  phone: 100,
  status: 110,
  outcome: 180,
  value: 80,
  date: 120
});

/**
 * Calculates the total minimum width needed for the table
 * @returns {number} Total width in pixels
 */
export const calculateTotalMinWidth = (): number => {
  const minColumnWidths = getMinColumnWidths();
  // Add some padding for better appearance
  return Object.values(minColumnWidths).reduce((sum, width) => sum + width, 0) + 30;
};
